import {createGrid} from "../../helpers/grids/grids";
import {createCellRenderer, createDoubleClickHandler} from "../../helpers/grids/helpers";
import createElement from "../../helpers/createElement";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {createModal} from "../../helpers/modal";

function initOrdersIndex() {

	const orderModal = createModal({
		modalContainer: null,
	});


	// Init grid
	createGrid('.orders-grid', {
			columnDefs: [
				{
					field: "type.name",
					headerName: 'Type',
					sortable: true,
				},
				{
					field: "route.name",
					headerName: 'Route',
					sortable: true,
					cellRenderer: createCellRenderer(params => {
						return createElement(`
							<div style="padding-top: 2px; padding-bottom: 2px">
								<div style="line-height: normal">${params.data.route.name}</div>
								<div style="line-height: normal">
									<span class="mono-font text-muted">${params.data.input_api.name}</span>
									<i class="fa-solid fa-right-long"></i>
									<span class="mono-font text-muted">${params.data.output_api.name}</span>
								</div>
							</div>
						`);
					}),
					autoHeight: true,
				},
				{
					field: "fullName",
					headerName: 'Applicant',
					sortable: true,
				},
				{
					field: "status.name",
					headerName: 'Status',
					sortable: true,
					cellRenderer: createCellRenderer(params => {
						let statusDescription = params.data.status.description
						if (params.data.status.name === 'Cancelled') {
							statusDescription += ` - Error:  '${params.data.error}'`
						}

						return createElement(`
							<div title="${statusDescription}">${params.data.status.name}</div>
						`);
					})
				},
				{
					field: "created_at",
					headerName: 'Created',
					width: 200,
					sortable: true,
					sort: 'desc',
				},
				{
					field: "id",
					headerName: '',
					maxWidth: 240,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const buttons = createElement(`
                            <div class="buttons">
                                <button
                                 	class="btn btn-primary btn-sm view-order-button"
                                 	type="button"
                                 >
                                    View Order
								</button>
                            </div>`
						)

						const viewOrderButton = buttons.querySelector('.view-order-button')

						viewOrderButton.addEventListener('click', () => {
							displayOrderModal(params.data.orderModalRoute);
						})

						return buttons;
					})
				},
			],
			paginationPageSize: 20,
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				displayOrderModal(data.orderModalRoute);
			}),
			_rowName: 'orders',
			_autoRefresh: true,
		},
		window['routes/admin.orders.grid'],
	);


	/** Methods */
	function displayOrderModal(orderModalRoute) {
		loading();

		Axios.post(orderModalRoute)
			.then(response => {
				orderModal.replace(createElement(response.data.modal));
				orderModal.display();
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {
	initOrdersIndex
}
